// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import UAT from '../../jsw/uat-base';
import { Cookie } from '../../jsw/cookie';

const uat = ({ userActivityTracking: { enabled, dummyRequest, firehose, debug }, instanceId }) => {
    if (!enabled) {
        return;
    }

    UAT.init({
        instanceId: Cookie.get('uat-iid') || instanceId,
        accountLevel: 'admin',
        accountId: '1',
        sessionId: Cookie.get('uat-sid') || '0000',
        firehose: dummyRequest ? null : firehose,
        // eslint-disable-next-line no-console
        logger: debug ? console.log : null,
    });
};

export default uat;



// WEBPACK FOOTER //
// ./app/repair/uat.js